import {Injectable} from '@angular/core';
import {ResourceService} from '~/app/core/common/services/ResourceService';
import {ConfirmationItem} from '~/app/core/common/models/confirmationitem';
import {ConfirmationSerializer} from '~/app/core/common/serializers/ConfirmationSerializer';
import {catchError, map} from 'rxjs/operators';
import {ApiService} from '~/app/core/common/services/api.service';
import {BaseService} from '~/app/core/common/services/base.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService extends ResourceService<ConfirmationItem> {
    get confirmationItemList(): ConfirmationItem[] {
        return this._confirmationItemList;
    }

    set confirmationItemList(value: ConfirmationItem[]) {
        this._confirmationItemList = value;
    }

    private _confirmationItemList: ConfirmationItem[] = [];
    showConfirmations: boolean;
    useStore: boolean;

    constructor(public baseService: BaseService,
                public apiService: ApiService,
                private _applicationSettingsHelper: ApplicationSettingsHelper
    ) {
        super(baseService,
            '',
            '',
            new ConfirmationSerializer());
        this.showConfirmations = false;
    }

    public getStoreConfirmations(storeNumber: string) {

        if (storeNumber == null || storeNumber === '' || storeNumber === '-2' || storeNumber === undefined || storeNumber === 'undefined') {
            this.useStore = false;
            console.error('No Store Number specified for getStoreConfirmations');
        } else {
            this.useStore = true;
        }
        return this.baseService.getHttpObject<ConfirmationItem>(
            'getStoreConfirmations',
            'confirmation-service',
            this.apiService.confirmationItemsURL + (this.useStore ? storeNumber : this._applicationSettingsHelper.getCustomerId()))
            .pipe(catchError(this.handleError))
            .pipe(map((data: any) => this.convertData(data)));
    }

    public getStoreConfirmationsCount(storeNumber: string) {
        if (storeNumber == null || storeNumber === '' || storeNumber === '-2' || storeNumber === undefined) {
            this.useStore = false;
            console.error('No Store Number specified for getStoreConfirmationsCount');
        } else {
            this.useStore = true;
        }
        return this.baseService.getHttpObject<number>(
            'getStoreConfirmationsCount',
            'confirmation-service',
            this.apiService.confirmationCountURL + (this.useStore ? storeNumber : this._applicationSettingsHelper.getCustomerId()));
    }

    public acknowledgeItems(storeNumber: string) {
        if (storeNumber == null || storeNumber === '' || storeNumber === '-2' || storeNumber === undefined) {
            this.useStore = false;
            console.error('No Store Number specified for acknowledgeItems');
        } else {
            this.useStore = true;
        }
        return this.baseService.putHttp(
            'acknowledgeItems',
            'confirmation-service',
            this.apiService.confirmationAcknowledgeURL + storeNumber !== undefined ? storeNumber : this._applicationSettingsHelper.getCustomerId())
            .pipe(catchError(this.handleError))
            .pipe(map((data: any) => data));
    }

    public async getStoreConfirmation() {
        if (this._applicationSettingsHelper.getCustomerId() == null
            || this._applicationSettingsHelper.getCustomerId() === ''
            || this._applicationSettingsHelper.getCustomerId() === '-2'
            || this._applicationSettingsHelper.getCustomerId() === undefined) {
            this.useStore = false;
            console.error('No Store Number specified for getStoreConfirmation');
        } else {
            this.useStore = true;
        }
        this.confirmationItemList = await this.baseService.getHttpObject(
            'getStoreConfirmation',
            'confirmation-service',
            this.apiService.confirmationItemsURL + this._applicationSettingsHelper.getCustomerId())
            .toPromise()
            .then(results => results as ConfirmationItem[]);
    }
}
